import React from 'react';
import {useNavigate, useParams, useLocation} from 'react-router-dom';

/**
 * Higher-order component to provide React Router v6 hooks to class components
 * Usage: export default withRouter(YourClassComponent);
 */
export default function withRouter(Component) {
	function ComponentWithRouterProp(props) {
		const navigate = useNavigate();
		const params = useParams();
		const location = useLocation();

		return (
			<Component
				{...props}
				router={{navigate, params, location}}
				navigate={navigate}
			/>
		);
	}

	return ComponentWithRouterProp;
}
